<template>
  <Card class="m-3">
    <template #title="">Map Report</template>
    <template #content="">
      <div class="grid">
        <div class="col-12 md:col-2 field p-fluid">
          <label for="calendar">วันที่รายงาน</label>
          <Calendar id="calendar" v-model="screen.selectedDate"></Calendar>
        </div>
        <div class="col-12 md:col-2 field p-fluid">
          <label for="shipmentNo">ระบุ Shipment</label>
          <Dropdown
            id="shipmentNo"
            v-model="screen.shipmentNo"
            :options="shipments"
            optionValue="code"
            optionLabel="description"
          ></Dropdown>
        </div>
        <div class="col-12 md:col-2 field flex flex-column justify-content-end">
          <Button icon="pi pi-search"></Button>
        </div>
        <div class="col-12" style="height: 50vh">
          <l-map :center="[8, 103]" :zoom="10">
            <l-tile-layer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            ></l-tile-layer>
          </l-map>
        </div>
      </div>
    </template>
  </Card>
</template>

<script lang="ts">
import { usePlugin } from "@/plugins";
import { defineComponent, reactive, ref } from "vue";
import { LMap, LTileLayer } from "@vue-leaflet/vue-leaflet";

export default defineComponent({
  name: "MapReport",
  components: { LMap, LTileLayer },
  setup() {
    const { dayjs } = usePlugin();
    const shipments = ref([
      { code: "11111", description: "11111 - 8400001" },
      { code: "22211", description: "22211 - 8400001" },
    ]);
    const screen = reactive({
      selectedDate: dayjs().toDate(),
      shipmentNo: "",
    });
    return { shipments, screen };
  },
});
</script>

<style></style>
